/**
 * LanguageToggle — segmented VN/EN switcher for the topbar.
 *
 * Reads/writes i18next.language. Persistence is handled by
 * LanguageDetector (caches: ['localStorage'], key 'ams.lang') configured in
 * src/i18n/index.js — no extra work needed here.
 *
 * Usage:
 *   import { LanguageToggle } from '@/shared/ui';
 *   <LanguageToggle />
 *   <LanguageToggle size="md" />
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonGroup } from './Button';

const OPTIONS = [
  { value: 'vi', label: 'VN' },
  { value: 'en', label: 'EN' },
];

export function LanguageToggle({ size = 'sm' }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || 'vi').toLowerCase().startsWith('en') ? 'en' : 'vi';

  return (
    <ButtonGroup
      value={current}
      onChange={(v) => i18n.changeLanguage(v)}
      options={OPTIONS}
      size={size}
      ariaLabel="Language"
    />
  );
}
